export enum projectDomains {
  lernaBy = 'lerna.by',
  lernaGroup = 'lerna.group',
  myskillsTeam = 'myskills.team',
  lernaUz = 'lerna.uz',
}
